var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, css } from 'lit';
import { property, query } from 'lit/decorators.js';
import { uniqueId } from 'lodash-es';
import { SdsContextMenuGroup } from '../context-menu/group/sds-cm-group.lit';
import { SdsContextMenuActionItem, } from '../context-menu/item/sds-cm-action-item.lit';
import { SdsContextMenuExpandableItem } from '../context-menu/item/sds-cm-expandable-item.lit';
import { SdsContextMenuItem } from '../context-menu/item/sds-cm-item.lit';
import { SdsContextMenuSelectItem, } from '../context-menu/item/sds-cm-select-item.lit';
import { sdsCustomElement } from '../utilities/custom-components';
import { cleanMenuItemsFocus, initMenuItemsFocusForButtonDropdown, } from '../dropdown/menu-items-state-handler';
/**
 * `sds-menu` is a web component that represents a contextual menu for user interactions.
 * It allows users to access various actions and options in a compact format, with customizable size and positioning.
 *
 * ### Attributes
 * - `size`: The size of the menu, which can be 'sm', 'md', 'lg', or 'xs'. Defaults to `'sm'`.
 * - `position`: The position of the menu in relation to its trigger element, which can be 'below' or 'beside'. Defaults to `'below'`.
 * - `persistent`: A boolean indicating whether the menu should remain open when clicking on the overlay. Defaults to `false`.
 *
 * @tag sds-menu
 */
let SdsMenu = (() => {
    var _SdsMenu_size_accessor_storage, _SdsMenu_position_accessor_storage, _SdsMenu_persistent_accessor_storage, _SdsMenu_opened_accessor_storage, _SdsMenu__contextMenu_accessor_storage, _SdsMenu__menuContent_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-menu')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    let _position_decorators;
    let _position_initializers = [];
    let _position_extraInitializers = [];
    let _persistent_decorators;
    let _persistent_initializers = [];
    let _persistent_extraInitializers = [];
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __menuContent_decorators;
    let __menuContent_initializers = [];
    let __menuContent_extraInitializers = [];
    var SdsMenu = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsMenu_size_accessor_storage.set(this, __runInitializers(this, _size_initializers, 'sm'));
            _SdsMenu_position_accessor_storage.set(this, (__runInitializers(this, _size_extraInitializers), __runInitializers(this, _position_initializers, 'below')));
            _SdsMenu_persistent_accessor_storage.set(this, (__runInitializers(this, _position_extraInitializers), __runInitializers(this, _persistent_initializers, false)));
            _SdsMenu_opened_accessor_storage.set(this, (__runInitializers(this, _persistent_extraInitializers), __runInitializers(this, _opened_initializers, false)));
            _SdsMenu__contextMenu_accessor_storage.set(this, (__runInitializers(this, _opened_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsMenu__menuContent_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __menuContent_initializers, void 0)));
            this._openedViaKeyboard = (__runInitializers(this, __menuContent_extraInitializers), false);
            this.onContentChange = () => {
                const items = this._menuContent.assignedElements();
                items.forEach(item => this.menuItemFirstUpdate(item));
                // Set aria-haspopup on trigger element's shadow root content
                const trigger = this.querySelector('[slot="trigger"]');
                if (trigger && trigger.shadowRoot) {
                    // Look for button or other interactive elements in shadow root
                    const button = trigger.shadowRoot.querySelector('button');
                    if (button) {
                        button.setAttribute('aria-haspopup', 'true');
                    }
                }
                this.requestUpdate();
            };
            this.handleMenuItemClick = (event) => {
                this.dispatchMenuActionEvent(event.detail.identifier, 'click');
                if (!this.persistent) {
                    this.hideMenu();
                }
            };
            this.handleMenuItemSelectionChange = (event) => {
                this.dispatchMenuActionEvent(event.detail.identifier, event.detail.selected ? 'select' : 'unselect');
            };
            this.handleMenuItemAction = (event) => {
                this.dispatchMenuActionEvent(event.detail.identifier, 'click');
            };
            this.handleTriggerKeyDown = (event) => {
                var _a, _b;
                switch (event.code) {
                    case 'Space':
                    case 'Enter':
                    case 'ArrowDown':
                        if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                            event.preventDefault();
                            event.stopPropagation();
                            this.openMenu(event.target, true);
                        }
                        break;
                    case 'Escape':
                        if ((_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.opened) {
                            event.preventDefault();
                            this.hideMenu();
                        }
                        break;
                }
            };
            this.toggleMenu = (event) => {
                const trigger = event.target;
                if (trigger && this._contextMenu) {
                    if (!this._contextMenu.opened) {
                        this.openMenu(trigger, false);
                    }
                    else {
                        this.hideMenu();
                    }
                }
            };
            this.openMenu = (trigger, openedViaKeyboard = false) => {
                if (this._contextMenu) {
                    // Pass isSelectMenu: false to enable keyboard navigation for menu items
                    this._contextMenu.show(trigger, false);
                    this.opened = true;
                    trigger.setAttribute('selected', 'true');
                    this.dispatchOpenEvent();
                    initMenuItemsFocusForButtonDropdown(this._contextMenu);
                    // Store whether menu was opened via keyboard for focus management
                    this._openedViaKeyboard = openedViaKeyboard;
                    // Override the context menu's hide method to control focus behavior
                    const originalHide = this._contextMenu.hide;
                    this._contextMenu.hide = (focusTrigger = true) => {
                        const shouldFocus = focusTrigger;
                        originalHide.call(this._contextMenu, shouldFocus);
                    };
                }
            };
            this.hideMenu = () => {
                var _a;
                if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                    this._contextMenu.hide();
                    this.cleanupMenuState();
                }
            };
            this.handleMenuClosed = () => {
                this.cleanupMenuState();
            };
            this.handleMouseup = (event) => {
                var _a;
                if (!this.isThisTarget(event)) {
                    // Don't focus trigger when clicking outside
                    (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.hide(false);
                    this.cleanupMenuState();
                }
            };
            this.calculateMenuSize = () => {
                let size;
                switch (this.size) {
                    case 'lg':
                        size = 400;
                        break;
                    case 'md':
                        size = 320;
                        break;
                    case 'sm':
                        size = 240;
                        break;
                    case 'xs':
                        size = 160;
                        break;
                    default:
                        return undefined;
                }
                return `${size}px`;
            };
        }
        /**
         * The size of the menu.
         * This attribute allows you to customize the dimensions of the menu to fit different use cases.
         *
         * Defaults to `'sm'`.
         *
         * @attr {MenuSize} size - The menu size. Possible values are:
         * - `'lg'`
         * - `'md'`
         * - `'sm'`
         * - `'xs'`
         */
        get size() { return __classPrivateFieldGet(this, _SdsMenu_size_accessor_storage, "f"); }
        set size(value) { __classPrivateFieldSet(this, _SdsMenu_size_accessor_storage, value, "f"); }
        /**
         * The position of the menu relative to its trigger element.
         * This attribute determines where the menu will appear in relation to the element that triggered it.
         *
         * Defaults to `'below'`.
         *
         * @attr {PositionType} position - The menu position. Possible values are:
         * - `'below'`
         * - `'beside'`
         */
        get position() { return __classPrivateFieldGet(this, _SdsMenu_position_accessor_storage, "f"); }
        set position(value) { __classPrivateFieldSet(this, _SdsMenu_position_accessor_storage, value, "f"); }
        /**
         * Indicates if the menu is persistent.
         * When set to true, the menu remains open even when the user clicks outside of it.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} persistent - If true, the menu is persistent.
         */
        get persistent() { return __classPrivateFieldGet(this, _SdsMenu_persistent_accessor_storage, "f"); }
        set persistent(value) { __classPrivateFieldSet(this, _SdsMenu_persistent_accessor_storage, value, "f"); }
        /**
         * Controls whether the menu is open or closed.
         *
         * @attr {boolean} opened - Indicates if the menu is currently opened.
         * @default false
         */
        get opened() { return __classPrivateFieldGet(this, _SdsMenu_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsMenu_opened_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsMenu__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsMenu__contextMenu_accessor_storage, value, "f"); }
        get _menuContent() { return __classPrivateFieldGet(this, _SdsMenu__menuContent_accessor_storage, "f"); }
        set _menuContent(value) { __classPrivateFieldSet(this, _SdsMenu__menuContent_accessor_storage, value, "f"); }
        cleanupMenuState() {
            const trigger = this.querySelector('[slot="trigger"]');
            if (trigger) {
                trigger.removeAttribute('selected');
            }
            this.opened = false;
            this._openedViaKeyboard = false;
            cleanMenuItemsFocus(this._contextMenu, false); // Use false for menu items
            this.dispatchCloseEvent();
        }
        render() {
            return html `
            <slot
                name="trigger"
                @click="${this.toggleMenu}"
                @keydown="${this.handleTriggerKeyDown}"
            ></slot>

            <div id="menu-status" class="sr-only" aria-live="polite"></div>

            <sds-context-menu
                width="${this.calculateMenuSize()}"
                position="${this.position}"
                @menu-closed="${this.handleMenuClosed}"
            >
                <slot id="menu-content" @slotchange="${this.onContentChange}"></slot>
            </sds-context-menu>
        `;
        }
        isOpened() {
            return this._contextMenu.opened;
        }
        connectedCallback() {
            super.connectedCallback();
            window.addEventListener('resize', this.hideMenu);
            document.addEventListener('mouseup', this.handleMouseup);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener('resize', this.hideMenu);
            document.removeEventListener('mouseup', this.handleMouseup);
            this.hideMenu();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        menuItemFirstUpdate(item) {
            var _a, _b;
            this.setMenuItemIdentifierIfNeeded(item);
            if (item instanceof SdsContextMenuGroup) {
                item.content.forEach(groupItem => {
                    this.menuItemFirstUpdate(groupItem);
                });
            }
            if (item instanceof SdsContextMenuActionItem) {
                item.addEventListener(SdsContextMenuActionItem.CM_ACTION_ITEM_CLICKED, this.handleMenuItemAction);
            }
            else if (item instanceof SdsContextMenuExpandableItem) {
                const nestedItems = (_b = (_a = item.getMenu()) === null || _a === void 0 ? void 0 : _a.querySelector('slot')) === null || _b === void 0 ? void 0 : _b.assignedElements();
                if (nestedItems) {
                    for (let i = 0; i < nestedItems.length; i++) {
                        const menuItem = nestedItems[i];
                        this.menuItemFirstUpdate(menuItem);
                    }
                }
            }
            else if (item instanceof SdsContextMenuSelectItem) {
                item.addEventListener(SdsContextMenuSelectItem.CM_ITEM_SELECTION_CHANGE, this.handleMenuItemSelectionChange);
            }
            else {
                item.addEventListener(SdsContextMenuItem.CM_ITEM_CLICKED, this.handleMenuItemClick);
            }
        }
        setMenuItemIdentifierIfNeeded(item) {
            if (!item.identifier) {
                item.identifier = uniqueId('menu-item-');
            }
        }
        dispatchMenuActionEvent(identifier, action) {
            this.dispatchEvent(new CustomEvent(SdsMenu.MENU_ACTION, {
                detail: {
                    identifier,
                    action,
                },
            }));
        }
        dispatchOpenEvent() {
            this.dispatchEvent(new CustomEvent(SdsMenu.OPEN_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        dispatchCloseEvent() {
            this.dispatchEvent(new CustomEvent(SdsMenu.CLOSE_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        isThisTarget(event) {
            if (!event) {
                return false;
            }
            if (event.target instanceof Element) {
                if (this.contains(event.target) || this.isSameNode(event.target)) {
                    return true;
                }
                return (!!this._contextMenu &&
                    (this._contextMenu.getMenu().contains(event.target) ||
                        this._contextMenu.getMenu().isSameNode(event.target)));
            }
            return false;
        }
    };
    _SdsMenu_size_accessor_storage = new WeakMap();
    _SdsMenu_position_accessor_storage = new WeakMap();
    _SdsMenu_persistent_accessor_storage = new WeakMap();
    _SdsMenu_opened_accessor_storage = new WeakMap();
    _SdsMenu__contextMenu_accessor_storage = new WeakMap();
    _SdsMenu__menuContent_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsMenu");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _size_decorators = [property()];
        _position_decorators = [property()];
        _persistent_decorators = [property({ type: Boolean })];
        _opened_decorators = [property({ type: Boolean })];
        __contextMenu_decorators = [query('sds-context-menu')];
        __menuContent_decorators = [query('#menu-content')];
        __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
        __esDecorate(_classThis, null, _position_decorators, { kind: "accessor", name: "position", static: false, private: false, access: { has: obj => "position" in obj, get: obj => obj.position, set: (obj, value) => { obj.position = value; } }, metadata: _metadata }, _position_initializers, _position_extraInitializers);
        __esDecorate(_classThis, null, _persistent_decorators, { kind: "accessor", name: "persistent", static: false, private: false, access: { has: obj => "persistent" in obj, get: obj => obj.persistent, set: (obj, value) => { obj.persistent = value; } }, metadata: _metadata }, _persistent_initializers, _persistent_extraInitializers);
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __menuContent_decorators, { kind: "accessor", name: "_menuContent", static: false, private: false, access: { has: obj => "_menuContent" in obj, get: obj => obj._menuContent, set: (obj, value) => { obj._menuContent = value; } }, metadata: _metadata }, __menuContent_initializers, __menuContent_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsMenu = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.MENU_ACTION = 'sds.menu.action';
    _classThis.OPEN_EVENT = 'sds.menu.opened';
    _classThis.CLOSE_EVENT = 'sds.menu.closed';
    _classThis.styles = css `
        .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border: 0;
        }
    `;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsMenu = _classThis;
})();
export { SdsMenu };
